import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { TriangleAlert } from "lucide-react";

interface DataErrorProps {
  topic: string;
}

export function DataError({ topic }: DataErrorProps) {
  return (
    <Card className="w-full border-l-8">
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-lg">
          <TriangleAlert className="h-6 w-6" />
          Unable to load {topic}
        </CardTitle>
      </CardHeader>
      <CardContent className="ml-8">Contact customer support</CardContent>
    </Card>
  );
}
